// extracted by mini-css-extract-plugin
export var root = "ccdea41f7460533b4ee93c1279be64c0-css";